export default __webpack_public_path__ + "img/jUqGmSqN.a2cb8214.svg";